import { Diamond } from "lucide-react";

const ITEMS = [
  "Achat de véhicule",
  "Recherche privée",
  "Financement 1re · 2e · 3e chance",
  "Vente accompagnée",
  "Conciergerie automobile",
  "Gestion de flotte",
  "600+ véhicules en réseau",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-white/10 bg-anthracite py-5 overflow-hidden"
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-lg sm:text-xl text-slate-400 tracking-wide">{item}</span>
            <Diamond size={9} className="text-gold/60" fill="currentColor" />
          </span>
        ))}
      </div>
    </div>
  );
}
